<template>
  <div class="booking-concept-selector mx-1 mx-md-2">
    <div class="booking-concept-selector__header">
      <BookingStepHeader :step="step" :title="title" />
    </div>
    <div class="booking-concept-selector__content">
      <!-- 컨셉 미선택 상태 -->
      <div v-if="!selectedConcept" class="d-flex justify-center">
        <div class="concept-placeholder" @click="handleSelectClick">
          <span>{{ emptyText }}</span>
        </div>
      </div>

      <!-- 컨셉 선택 상태 -->
      <div v-else class="concept-selected-wrapper">
        <div class="d-flex align-center">
          <v-img
            :lazy-src="require('@/assets/placeholder.jpg')"
            :src="'/upload/concept/thumbnail_image/' + selectedConcept.thumbnail_image"
            position="top center"
            aspect-ratio="0.83"
            max-width="110px"
            class="concept-image"
            @click.stop="handleSelectClick"
            :class="disabled ? 'concept-image--disabled' : 'concept-image--selectable'"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0 align-center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>

          <div class="ml-4 flex-grow-1">
            <div class="concept-title">{{ getConceptTitle(selectedConcept) }}</div>
            <!-- <div v-if="selectedConcept.tag" class="concept-tags mt-2">
              <v-chip v-for="tag in getConceptTags(selectedConcept.tag)" :key="tag" x-small outlined color="grey" class="mr-1 mb-1">
                {{ tag }}
              </v-chip>
            </div> -->
            <!-- 상세사항 버튼 -->
            <v-btn small depressed color="#EF7FAB" dark class="detail-btn mt-2" @click.stop="handleDetailClick">
              {{ $t("page.reservation.concept-pattern-detail") }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingStepHeader from "./StepHeader"
import { mapState } from "vuex"

export default {
  name: "ConceptSelector",
  components: {
    BookingStepHeader,
  },
  props: {
    step: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: "컨셉 선택",
    },
    selectedConcept: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: "컨셉을 선택해주세요",
    },
  },
  computed: {
    ...mapState(["lang"]),
  },
  methods: {
    handleSelectClick() {
      if (!this.disabled) {
        this.$emit("select")
      }
    },
    handleDetailClick() {
      this.$emit("detail")
    },
    getConceptTitle(concept) {
      if (!concept) return ""
      switch (this.lang) {
        case "en":
          return concept.title_en || concept.title
        case "jp":
          return concept.title_jp || concept.title
        default:
          return concept.title
      }
    },
    getConceptTags(tagStr) {
      if (!tagStr) return []
      return tagStr.split(",").map((tag) => tag.trim())
    },
  },
}
</script>

<style scoped>
.booking-concept-selector {
  background-color: #ffefef;
  border-radius: 12px;
  padding: 16px 8px 16px;
}

.booking-concept-selector__header {
  margin-bottom: 20px;
}

.booking-concept-selector__content {
  background-color: #fff;
  border-radius: 12px;
  padding: 8px;
}

.concept-placeholder {
  border: 3px solid #f5e4e4;
  border-radius: 8px;
  width: 180px;
  height: 216px;
  cursor: pointer;
  color: #8d8d8d;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
}

.concept-placeholder:hover {
  border-color: #ef7fab;
}

.concept-placeholder span {
  color: #8d8d8d;
  font-size: 14px;
}

.concept-image {
  border: 3px solid #f5e4e4;
  border-radius: 8px;
  flex-shrink: 0;
}

.concept-image--selectable {
  cursor: pointer;
  transition: all 0.2s;
}

.concept-image--selectable:hover {
  border-color: #ef7fab;
}

.concept-image--disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.concept-title {
  font-size: 18px;
  font-weight: 600;
  color: #545454;
}

.concept-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.concept-selected-wrapper {
  position: relative;
}

.detail-btn {
  font-size: 14px;
  min-width: 80px;
}
</style>
